import Vue from 'vue'
import App from './App.vue'
import VueCarousel from 'vue-carousel';
import VueScrollReveal from 'vue-scroll-reveal';
import VueScrollTo from 'vue-scrollto'
import router from './router'
import VueGtag from 'vue-gtag'
import VueYouTubeEmbed from 'vue-youtube-embed'
import VueFacebookPixel from 'vue-analytics-facebook-pixel'
import VueSocialSharing from 'vue-social-sharing'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VTooltip from 'v-tooltip'


Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueYouTubeEmbed);
Vue.use(VTooltip)
Vue.use(VueCarousel);
Vue.use(VueFacebookPixel);
Vue.use(VueSocialSharing);


Vue.use(VueGtag, {
  config: {
    id: 'UA-49801007-6'
  }
}, router);

Vue.use(VueScrollReveal, {
  class: 'v-scroll-reveal', // A CSS class applied to elements with the v-scroll-reveal directive; useful for animation overrides.
  duration: 800,
  scale: 1,
  distance: '10px',
  mobile: true
});

Vue.use(VueScrollTo, {
  container: "body",
  duration: 1000,
  easing: "ease-in-out",
  offset: -50,
  force: true,
  cancelable: true,
  onStart: false,
  onDone: false,
  onCancel: false,
  x: false,
  y: true
})


Vue.config.productionTip = false

Vue.analytics.fbq.init('606775859891974', {
  em: 'addiscamillo@gmail.com'
})

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')